// test1223
(1223 && 0);
